import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer,
  createMappedRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { normalize, schema } from 'normalizr'

const normalizeGroups = data => {
  const group = new schema.Entity('groups')
  return normalize(data, [group])
}

const GroupsReducer = combineReducers({
  fetching: createRequestReducer('GROUPS_STORE:FETCHING', { pending: true }),
  creating: createRequestReducer('GROUPS_STORE:CREATE'),
  deleting: createMappedRequestReducer('GROUPS_STORE:DELETE'),
  updating: createMappedRequestReducer('GROUPS_STORE:UPDATE'),
  categories: createReducer(null, {
    'GROUPS_STORE:FETCHING_REQUEST_SUCCESS': (state, { response }) =>
      response.data.school.group_categories
  }),
  groups: createReducer(
    {},
    {
      'GROUPS_STORE:CREATE_REQUEST_SUCCESS': (state, { params, response }) => {
        const entities = { ...state.entities.groups }
        const group = response.data.group
        delete entities[params.id]
        const result = state.result.filter(id => id !== params.id)
        return {
          entities: {
            groups: {
              ...entities,
              [response.data.group.id]: group
            }
          },
          result: [response.data.group.id, ...result]
        }
      },
      'GROUPS_STORE:FETCHING_REQUEST_SUCCESS': (state, { response }) =>
        normalizeGroups(response.data.school.groups),
      'GROUPS_STORE:DELETE_REQUEST_SUCCESS': (state, { params }) => ({
        ...state,
        result: state.result.filter(id => id !== params.id)
      }),
      'GROUPS_STORE:UPDATE_REQUEST_SUCCESS': (state, { params, response }) => ({
        ...state,
        entities: {
          groups: {
            ...state.entities.groups,
            [params.id]: response.data.group
          }
        }
      })
    }
  )
})

export default GroupsReducer
